// src/pages/ManageCustomerReport/ManageCustomerReport.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box,Card, CardContent, Typography, Grid, CardActionArea } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExchangeAlt,
  faTrophy,
  faBalanceScale,
  faCoins,
  faMoneyBillTransfer,
  faGamepad,
  faMagnifyingGlass,
  faMobile
} from '@fortawesome/free-solid-svg-icons';
import {jwtDecode} from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/constants';
import BackButton from '../../components/BackButton';

// Define the Customer report data as a constant
const customerReportData = [
  {
    title: 'Transactions',
    icon: faExchangeAlt,
    path: 'transactions',
    modules: [3810],
  },
  {
    title: 'Rewards Trans..',
    icon: faTrophy,
    path: 'rewards',
    modules: [3811],
  },
  {
    title: 'Reward Balance',
    icon: faBalanceScale,
    path: 'balance',
    modules: [3812],
  },
  {
    title: 'Games',
    icon: faGamepad,
    path: 'games',
    modules: [3813],
  },
  {
    title: 'Welfare Transactions',
    icon: faCoins,
    path: 'welfare-transactions',
    modules: [3814],
  },
  {
    title: 'Welfare Handle ',
    icon: faMoneyBillTransfer,
    path: 'handle-welfare',
    modules: [3815],
  },
  {
    title: 'VPA Search',
    icon: faMagnifyingGlass,
    path: 'search/vpa-search',
    modules: [3816],
  },
  {
    title: 'Mobile Search',
    icon: faMobile,
    path: 'search/mobile-search',
    modules: [3817],
  },
  // Add more reports if needed
];

const ManageCustomerReport = () => {
  const [userLevel, setUserLevel] = useState(null);
  const [userModules, setUserModules] = useState([]);
  const navigate = useNavigate();

 // Fix for ManageCustomerReport.jsx - Update useEffect to include level 2
useEffect(() => {
  // Decode the JWT and store the user level and userId
  const token = sessionStorage.getItem('token');
  if (token) {
    const decodedToken = jwtDecode(token);
    setUserLevel(decodedToken.level);

    // Fix: Include both level 1 (Super Admin) and level 2 (State Admin)
    if (decodedToken.level === 1 || decodedToken.level === 2) {
      // If user is SuperAdmin or State Admin, grant access to all modules
      setUserModules(customerReportData.flatMap(report => report.modules));
    } else {
      // Otherwise, fetch the modules from the privileges stored in the backend
      fetchUserPrivileges(decodedToken.userId);
    }
  }
}, []);

// Update fetchUserPrivileges to match working MSB code
const fetchUserPrivileges = async (userId) => {
  try {
    // Use same endpoint as working MSB code
    const response = await axios.get(`${API_BASE_URL}/privileges/modules/${userId}`);
    if (response.status === 200 && response.data.modules) {
      setUserModules(response.data.modules);
    } else {
      console.error('Failed to fetch user privileges or no modules found');
    }
  } catch (error) {
    console.error('Error fetching user privileges:', error);
  }
};



  // Handler for card click
  const handleCardClick = (path) => {
    navigate(`/customer-report/${path}`);
  };

  // Function to check if the user has access to a specific module
  const hasAccess = (modules) => {
    return modules.some(moduleId => userModules.includes(moduleId));
  };

  return (
     <Box sx={{ position: 'relative', padding: 2 }}>
                  {/* Place BackButton outside the Grid */}
                  <BackButton />
                  <br/>  <br/>
    <Grid container spacing={3} alignItems="center">
      {customerReportData.map((report) => (
        hasAccess(report.modules) && (
          <Grid item xs={12} sm={6} md={4} key={report.title}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 225,
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '& .MuiTypography-root': {
                    color: 'white !important',
                  },
                  '& .fa-icon': {
                    color: 'white !important',
                  },
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(report.path)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={report.icon}
                    size="5x"
                    className="fa-icon"
                    style={{ color: 'orange' }}
                  />
                  <Typography gutterBottom variant="h5" component="div" sx={{ marginTop: 2 }}>
                    {report.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )
      ))}
    </Grid>
    </Box>
  );
};

export default ManageCustomerReport;
